import config from '../../config';

export default {
  url: `${config.api.baseURL}/steps`,
  transformer(data) {
    return data;
  }
};
